// extracted by mini-css-extract-plugin
module.exports = {"link":"NounsDAONounContent_link__30xRi","bidRow":"NounsDAONounContent_bidRow__3TLAG","currentBidCol":"NounsDAONounContent_currentBidCol__2BLxx"};